/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Pinned_BadgeInputs */



/**
* | output |
* | --- |
* | "Pinned" |
*
* @param {Voice_Manager_Pinned_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_pinned_badge = /** @type {((inputs?: Voice_Manager_Pinned_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Pinned_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Épinglée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Angeheftet")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fissata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закреплён")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fijada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已固定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ピン留め済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिन किया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Afixada")
	return /** @type {LocalizedString} */ ("Pinned")
});